import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Select2OptionData } from 'ng2-select2';

import swal from 'sweetalert2';
import { SpecialtiesService } from '../../../shared/services/specialties.service';
import { DoctorService } from '../../../shared/services/doctor.service';
import { AppointmentService } from '../../../shared/services/appointment.service';
import { AppointmentAvalaible } from '../../../shared/models/appointment-avalaible.model';
import { UserService } from '../../../shared/services/user.service';
import { MedicalCenterService } from '../../../shared/services/medical-center.service';
import { reject } from 'q';
import { MedicalCenter } from '../../../shared/models/medical-center.model';
import { CitieService } from '../../../shared/services/citie.service';
import { transition } from '@angular/animations/src/animation_metadata';
import { ToastrService } from 'ngx-toastr';

declare var jQuery: any;

@Component({
  selector: 'app-request-appointment',
  templateUrl: './request-appointment.component.html',
  styleUrls: ['./request-appointment.component.css']
})
export class RequestAppointmentComponent implements OnInit {

  nombreBeneficiario: string;
  documentoBeneficiario: string;
  carneBeneficiario: string;
  edad: number;


  //public centrosMedicos: Select2OptionData[];
  public ciudades: Select2OptionData[];
  public especialidades: Select2OptionData[];
  public prestadores: Select2OptionData[];
  public medicosEspecificos: Select2OptionData[];

  public listadoCentrosMedicos: MedicalCenter[];

  public selectedCentroMedico: string;
  public selectTextCentroMedico: string;
  public selectedCiudad: string;
  public selectTextCiudad: string;
  public selectedEspecialidad: string;
  public selectTextEspecialidad: string;
  public selectedPrestador: string;
  public selectTextPrestador: string;
  public selectedMedicoEspecifico: string;
  public selectTextMedicoEspecifico: string;
  public mensajeCitasDisponibles: string;
  public filtroDataSede: string;
  public filtroDataMedico: string;
  public filtroDataFecha: string;
  public filtroDataHora: string;

  public tipoCita: string;

  public tipoCitas = [
    { value: '1', display: 'Cita Disponible' },
    { value: '2', display: 'Médico Específico' }
  ];

  public citasDisponibles: Array<AppointmentAvalaible>;

  public citasDisponiblesLista: Array<AppointmentAvalaible>;

  collapseInDatosContrato = false;

  collapseInBeneficiario = false;

  showSpinnerEspecialidades: boolean;

  showSpinnerMedicos: boolean;

  showSpinnerCentrosMedicos: boolean;

  showSpinnerCiudades: boolean;

  showEspecialidadesXCiudad: boolean;

  showPrestadoresXCiudad: boolean;

  showSpinnerEspecialidadesXCiudad: boolean;

  showSpinnerPrestadoresXCiudad: boolean;

  numeroCitasDisponibles: number;

  tipoBusqueda: string;

  irSeleccionCita: boolean;

  activarReservaCita: boolean;

  public tiposBusqueda = [
    { value: 'E', display: 'Especialidad' },
    { value: 'P', display: 'Profesional' }
  ];

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _specialtiesService: SpecialtiesService,
    private _doctorService: DoctorService,
    private _appointmentService: AppointmentService,
    private _userService: UserService,
    private _medicalCenterService: MedicalCenterService,
    private _citiesService: CitieService,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    this.filtroDataSede = "";
    this.filtroDataMedico = "";
    this.filtroDataFecha = "";
    this.filtroDataHora = "";
    this.selectedCiudad = '';
    this.selectedCentroMedico = '';
    this.selectedEspecialidad = '';
    this.selectedMedicoEspecifico = '';
    this.tipoCita = '';
    this.tipoBusqueda = ''
    this.selectedPrestador = '';
    this.showSpinnerEspecialidades = false;
    this.showSpinnerMedicos = false;
    this.showPrestadoresXCiudad = false;
    this.showEspecialidadesXCiudad = false;
    this.showSpinnerPrestadoresXCiudad = false;
    this.showSpinnerEspecialidadesXCiudad = false;

    this.nombreBeneficiario = sessionStorage.getItem('nombreBeneficiario');
    this.documentoBeneficiario = sessionStorage.getItem('documentoBeneficiario');
    this.carneBeneficiario = sessionStorage.getItem('carneBeneficiario');
    this.edad = parseInt(sessionStorage.getItem('edad'));
    //  this.edad = 60;

    if (this.edad >= 60) {
      swal({
        // title: 'Incidunt ipsam fugiat',
        html: '<p style="font-size:17px; text-align: justify">Apreciado usuario, tu salud es lo mas importante para nosotros, por eso, si eres mayor de <b>60 años</b> te recomendamos que uses preferiblemente los servicios virtuales que tenemos para ti, queremos cuidarte a ti y todos los tuyos.</p>',
        type: 'info',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false,
        width: '355px'
        
      });
    }
    /*
        this.showSpinnerCentrosMedicos = true;
        this._medicalCenterService.getMedicalCenterPanacea().subscribe(
          res => {
    
            this.listadoCentrosMedicos = res;
            //console.log(res);
    
            let _array = [];
    
            for (let r of res) {
              let _obj = {
                id: r.codCenter,
                text: r.nameCenter + ' ( ' + r.addressCenter + ' - ' + r.city + ' )'
              };
              _array.push(_obj);
            }
    
            let _optionDefault = this.getOptionDefault();
            let _optionCentrosMedicos = _array;
            let _options = _optionDefault.concat(_optionCentrosMedicos);
            this.showSpinnerCentrosMedicos = false;
            this.centrosMedicos = _options;
    
          },
          err => {
    
            this.showSpinnerCentrosMedicos = false;
            console.log(err);
    
          }
        )
    */
    this.showSpinnerCiudades = true;
    this._citiesService.getCitiesPanacea().subscribe(
      res => {
        let _array = [];

        for (let r of res) {
          let _obj = {
            id: r.id,
            text: r.text
          };
          _array.push(_obj);
        }

        let _optionDefault = this.getOptionDefault();
        let _optionCiudades = _array;
        let _options = _optionDefault.concat(_optionCiudades);
        this.showSpinnerCiudades = false;
        this.ciudades = _options;
      },
      err => {
        this.showSpinnerCiudades = false;
        console.log(err);
      }
    )
  }

  clickPanelHeadindDatosContrato() {
    this.collapseInDatosContrato = !this.collapseInDatosContrato;
  }

  clickPanelHeadindBeneficiario() {
    this.collapseInBeneficiario = !this.collapseInBeneficiario;
  }


  getOptionDefault(): any[] {
    return [{ id: '-1', text: 'Seleccione una opción...' }];
  }

  public changedCentrosMedicos(e: any): void {

    this.selectedCentroMedico = e.value;
    this.selectTextCentroMedico = e.data[0].text;

    this.selectedEspecialidad = '';
    this.tipoCita = '';

    this.showSpinnerEspecialidades = true;
    this.especialidades = undefined;
    this._specialtiesService.getSpecialtiesPanacea(this.selectedCentroMedico, this.documentoBeneficiario).subscribe(
      res => {
        let _optionDefault = this.getOptionDefault();
        let _optionSpecialties = res;
        let _options = _optionDefault.concat(_optionSpecialties);
        this.showSpinnerEspecialidades = false;
        this.especialidades = _options;

      },
      err => {
        this.showSpinnerEspecialidades = false;
        console.log(err);
      }
    )

  }

  public changedEspecialidades(e: any): void {



    this.selectedEspecialidad = e.value;
    this.selectTextEspecialidad = e.data[0].text;

    if (this.selectedEspecialidad != '-1') {
      this.tipoCita = '';
      this.showSpinnerMedicos = true;
      this._doctorService.getDoctorsPanacea(this.selectedEspecialidad, this.selectedCentroMedico).subscribe(
        res => {
          this.showSpinnerMedicos = false;
          this.medicosEspecificos = res;
        },
        err => {
          this.showSpinnerMedicos = false;
          console.log(err);
        }
      );
    }

    if (this.selectTextEspecialidad.includes("TELEMEDICINA")) {

      this.toastr.info('<p>Para el servicio de videoconsulta, debes contar con una disponibilidad de 60 minutos a partir de la hora en la que selecciones tu cita para ser contactado por el profesional médico.</p>', 'Recuerda:', {
        tapToDismiss: false,
        enableHtml: true,
        timeOut: 0,
        closeButton: true,
        positionClass: 'toast-bottom-full-width'
      });

    }

  }

  public changedPrestadores(e: any): void {

    //console.log(e.value);
    this.selectedPrestador = e.value.split("-")[0];
    this.selectedEspecialidad = e.value.split("-")[1];
    this.selectTextEspecialidad = e.data[0].text.split("-")[1].replace('(', '').replace(')', '');
    this.selectTextPrestador = e.data[0].text;
  }

  public changedMedicosEspecificos(e: any): void {
    this.selectedMedicoEspecifico = e.value;
    this.selectTextMedicoEspecifico = e.data[0].text;
  }

  /*
  irEspecialidad() {

    if (this.selectedCentroMedico == '-1' || this.selectedCentroMedico == '') {
      swal({
        title: 'Centros Médicos',
        html: '<p style="font-size:14px">Seleccione un centro médico</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
    } else {
      this.removeClass();
      jQuery("#stepEspecialidad").addClass("active");
      jQuery("#tabEspecialidad").addClass("active");
    }
  }
  */

  changedTipoBusqueda(e: any): void {
    if (this.selectedCiudad !== '') {
      this.tipoBusqueda = e.value;
      this.cambiarListaOpciones()
    }

  }

  cambiarListaOpciones() {
    if (this.tipoBusqueda === 'E') {
      this.showEspecialidadesXCiudad = true;
      this.showPrestadoresXCiudad = false;
    }
    else if (this.tipoBusqueda === 'P') {
      this.showEspecialidadesXCiudad = false;
      this.showPrestadoresXCiudad = true;
    }
  }

  changedCiudades(e: any): void {
    this.selectedCiudad = e.value;
    this.selectTextCiudad = e.data[0].text;

    this.showEspecialidadesXCiudad = false;
    this.showSpinnerEspecialidadesXCiudad = true;
    this._specialtiesService.getSpecialtiesXCityPanacea(this.selectedCiudad, this.documentoBeneficiario).subscribe(
      res => {
        let _array = [];

        for (let r of res) {
          let _obj = {
            id: r.id,
            text: r.text
          };
          _array.push(_obj);
        }

        let _optionDefault = this.getOptionDefault();
        let _optionEspecialidades = _array;
        let _options = _optionDefault.concat(_optionEspecialidades);
        this.showSpinnerEspecialidadesXCiudad = false;
        this.especialidades = _options;
      },
      err => {
        this.showSpinnerEspecialidadesXCiudad = false;
        console.log(err);
      }
    )

    this.showPrestadoresXCiudad = false;
    this.showSpinnerPrestadoresXCiudad = true;
    this._doctorService.getDoctorsXCityPanacea(this.selectedCiudad, this.documentoBeneficiario).subscribe(
      res => {
        let _array = [];

        for (let r of res) {
          let _obj = {
            id: r.id,
            text: r.text
          };
          _array.push(_obj);
        }

        let _optionDefault = this.getOptionDefault();
        let _optionPrestadores = _array;
        let _options = _optionDefault.concat(_optionPrestadores);
        this.showSpinnerPrestadoresXCiudad = false;
        this.prestadores = _options;
      },
      err => {
        this.showSpinnerPrestadoresXCiudad = false;
        console.log(err);
      }
    )

    this.cambiarListaOpciones()
  }

  irCitasMedicas() {

    this.irSeleccionCita = true;

    //console.log(this.selectedCiudad);

    if (this.selectedCiudad === '-1' || this.selectedCiudad === '') {
      swal({
        title: 'Ciudades',
        html: '<p style="font-size:14px">Seleccione una ciudad</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });

      this.irSeleccionCita = false;
    }
    else {
      if (this.tipoBusqueda === '') {
        swal({
          title: 'Tipo de consulta',
          html: '<p style="font-size:14px">Seleccione un tipo de consulta</p>',
          type: 'warning',
          confirmButtonClass: 'btn btn-primary',
          buttonsStyling: false,
          focusConfirm: false
        });

        this.irSeleccionCita = false;
      }
    }

    if (this.irSeleccionCita === true) {
      if (this.tipoBusqueda === 'E') {
        this.selectedPrestador = '-1';

        if (this.selectedEspecialidad === '-1' || this.selectedEspecialidad === '') {
          swal({
            title: 'Especialidades',
            html: '<p style="font-size:14px">Seleccione una especialidad</p>',
            type: 'warning',
            confirmButtonClass: 'btn btn-primary',
            buttonsStyling: false,
            focusConfirm: false
          });

          this.irSeleccionCita = false;
        }
      }
      else {
        if (this.selectedPrestador === '-1' || this.selectedPrestador === '') {
          swal({
            title: 'Profesional',
            html: '<p style="font-size:14px">Seleccione un profesional</p>',
            type: 'warning',
            confirmButtonClass: 'btn btn-primary',
            buttonsStyling: false,
            focusConfirm: false
          });

          this.irSeleccionCita = false;
        }
      }
    }

    if (this.irSeleccionCita === true) {
      swal({
        //imageClass: 'imgLogo',
        //imageUrl: './assets/images/logo.png',
        //imageWidth: 100,
        width: 300,
        type: 'info',
        allowOutsideClick: false,
        //title: 'Citas Disponibles',
        html: '<p style="font-size: 20px">Buscando citas...</p>',
        onOpen: () => {
          swal.showLoading();
          this._appointmentService.getAvailablesSpecialtyLenderPanacea(this.documentoBeneficiario, this.selectedEspecialidad, this.selectedCiudad, 0, this.selectedPrestador).subscribe(
            res => {
              //console.log(res);
              swal.close();
              this.numeroCitasDisponibles = res.citasdisponibles.length;
              this.citasDisponibles = res.citasdisponibles;
              this.citasDisponiblesLista = res.citasdisponibles;
              this.activarReservaCita = res.disponible;
              this.removeClass();
              jQuery("#stepReservaCita").addClass("active");
              jQuery("#tabReservaCita").addClass("active");

              if (!res.disponible) {
                this.mensajeCitasDisponibles = res.mensaje;
              }

              //this._router.navigate(['/office/medical_appointment/request/#tableCitasDisp']);               
            },
            err => {
              swal.close();
              swal({
                title: 'Reserva cita',
                html: '<p style="font-size:14px">Existen algunos inconvenientes, por favor intente nuevamente.</p>',
                type: 'error',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
              });
            }
          );
        }
      });
    }
  }

  irCentrosMedicos() {
    this.removeClass();
    jQuery("#stepCentroMedico").addClass("active");
    jQuery("#tabCentroMedico").addClass("active");

  }

  public filtrarResultado() {

    let _array = [];

    for (let r of this.citasDisponiblesLista) {
      if (r.medico.toLowerCase().includes(this.filtroDataMedico.toLowerCase()) && r.sede.toLowerCase().includes(this.filtroDataSede.toLowerCase()) && r.fechaCita.includes(this.filtroDataFecha) && r.horaCita.includes(this.filtroDataHora)) {
        let _obj = {
          consecutivo: r.consecutivo,
          numeroCita: r.numeroCita,
          servicio: r.servicio,
          fechaCita: r.fechaCita,
          horaCita: r.horaCita,
          medico: r.medico,
          sede: r.sede,
          idSede: r.idSede,
          direccion: r.direccion
        };
        _array.push(_obj);
      }
    }

    this.citasDisponibles = _array;
    this.numeroCitasDisponibles = _array.length;
  }

  validaParametro(parametro: string): boolean {
    let retorno: boolean;
    retorno = false;

    if (parametro.trim() != '' && parametro.trim() != '-1') {
      retorno = true;
    }
    return retorno;
  }

  removeClass() {
    jQuery("ul.nav-tabs li").removeClass("active");
    jQuery("div.tab-pane").removeClass("active");
  }

  ReservarCitaMedica(cita: AppointmentAvalaible) {

    let _numeroCitaGenerada = '';

    let _direccion = '';

    _direccion = cita.direccion;
    this.selectedCentroMedico = cita.idSede;
    this.selectTextCentroMedico = cita.sede;

    let _html = '';
    _html += `
    <p style="font-size: 15px; text-align: left; font-weight: bold">Confirma la reserva de la cita médica:</p>
    <table id="tableResumenCitaMedica" class="table table-bordered">
      <tr>
        <td style="background-color: #1d7bbb; color: #ffff">Beneficiario</td>
        <td>${this.nombreBeneficiario}</td>
      </tr>
      <tr>
        <td style="background-color: #1d7bbb; color: #ffff">Identificación</td>
        <td>${this.documentoBeneficiario}</td>
      </tr>
      <tr>
      <td style="background-color: #1d7bbb; color: #ffff">Médico</td>
        <td>${cita.medico}</td>
      </tr> 
      <tr>
      <td style="background-color: #1d7bbb; color: #ffff">Especialidad</td>
      <td>${this.selectTextEspecialidad}</td>
      </tr>
      <tr>
      <td style="background-color: #1d7bbb; color: #ffff">Fecha cita</td>
        <td>${cita.fechaCita}</td>
      </tr>
      <tr>
      <td style="background-color: #1d7bbb; color: #ffff">Hora cita</td>
        <td>${cita.horaCita}</td>
      </tr>
      <tr>
      <td style="background-color: #1d7bbb; color: #ffff">Lugar</td>
      <td><p>${this.selectTextCentroMedico}</p><p>${_direccion}</p></td>
      </tr>    
     
    </table>    
    `;

    swal({
      width: 600,
      padding: 30,
      showCloseButton: true,
      type: 'question',
      html: _html,
      animation: true,
      allowOutsideClick: false,
      confirmButtonClass: 'btn btn-success btn-confirm-modal',
      confirmButtonText: 'Confirmar',
      showCancelButton: true,
      cancelButtonClass: 'btn btn-info',
      cancelButtonText: 'Cancelar',
      buttonsStyling: false,
      focusConfirm: false,
      showLoaderOnConfirm: true,
      onOpen: () => {
        jQuery("#tableResumenCitaMedica").addClass("tableConfirmaCitaMedica");
      },
      preConfirm: () => {
        return new Promise((resolve) => {

          let _obj = {
            codMedicalCenter: this.selectedCentroMedico,
            documentBeneficiary: this.documentoBeneficiario,
            consecutive: cita.consecutivo,
            appointmentNumber: cita.numeroCita,
            carneBeneficiary: this.carneBeneficiario,
            reschedule: 0,
            appointmentIdReschedule: 0
          }

          //console.log(_obj);

          this._appointmentService.getAvailablesSpecialtyLenderPanacea(this.documentoBeneficiario, this.selectedEspecialidad, this.selectedCiudad, 0, this.selectedPrestador).subscribe(
            resdis => {
              if (!resdis.disponible) {
                this.numeroCitasDisponibles = resdis.citasdisponibles.length;
                this.citasDisponibles = resdis.citasdisponibles;
                this.citasDisponiblesLista = resdis.citasdisponibles;
                this.activarReservaCita = resdis.disponible;
                this.removeClass();
                jQuery("#stepReservaCita").addClass("active");
                jQuery("#tabReservaCita").addClass("active");
                this.mensajeCitasDisponibles = resdis.mensaje;
                swal.showValidationError(resdis.mensaje);
                resolve();
                swal.close();
              }
              else {

                this._appointmentService.postGeneraCitaMedicaPanacea(_obj).subscribe(
                  res => {

                    //console.log(res);

                    if (res.id === '1#') {//1 Indica ejecucion satisfactoria
                      _numeroCitaGenerada = res.message;
                      resolve();
                    } else if (res.id === '-1') {//-1 Indica error en la ejecucion del metodo (Aplicativo Error)
                      swal.showValidationError('<span style="font-size: 15px">La cita no fue reservada, por favor intente nuevamente.</span>');
                      resolve();
                    } else if (res.id === '9#') {//9# Indica error en la ejecucion del SP (Sima Error)
                      swal.showValidationError('<span style="font-size: 15px">La cita no fue reservada,</br></br>posiblemente fue reservada en este momento por otro usuario,</br></br>por favor intente nuevamente.</span>');
                      resolve();
                    } else if (res.id === '9') {//9 Indica error en la ejecucion del SP (Sima Error)
                      swal.showValidationError('<span style="font-size: 15px">La cita no fue reservada, por favor intente nuevamente.</span>');
                      resolve();
                    } else {//Vacio Indica ejecucion sin parametros reconocidos
                      swal.showValidationError('<span style="font-size: 15px">La cita no fue reservada, por favor intente nuevamente.</span>');
                      resolve();
                    }
                  },
                  err => {
                    if (err.status === 406) {
                      swal.showValidationError('<span style="font-size: 15px">' + err.error.message + '</span>');
                    } else {
                      swal.showValidationError('<span style="font-size: 15px">Ocurrio un error, por favor intente nuevamente</span>');
                    }
                    resolve();
                  }
                );
              }


            }
          );
          //resolve(); 
        })
      }
    }).then((result) => {
      if (this.activarReservaCita) {
        if (result.value) {

          let _html = '';
          _html += `       
        <p style="font-size:14px">La cita fue asignada satisfactoriamente</p>
        <div style="text-align: right">
          <button id="btnPrint" type="button" class="btn btn-xs btn-default btn-image"
            title="Impresión Cita Médica">
            <img src="./assets/images/printer.png"  width="40"/>            
          </button> 
        </div> 
        <br/>
        <div id="contentPrinter">    
        <table id="tableCitaMedicaConfirmada" class="table table-bordered">
          <tr>
            <td style="background-color: #6bc048; color: #ffff">Beneficiario</td>
            <td>${this.nombreBeneficiario}</td>
          </tr>
          <tr>
            <td style="background-color: #6bc048; color: #ffff">Identificación</td>
            <td>${this.documentoBeneficiario}</td>
          </tr>
          <tr>
          <td style="background-color: #6bc048; color: #ffff">No. Cita</td>
            <td>${_numeroCitaGenerada}</td>
          </tr>
          <tr>
          <td style="background-color: #6bc048; color: #ffff">Médico</td>
            <td>${cita.medico}</td>
          </tr> 
          <tr>
          <td style="background-color: #6bc048; color: #ffff">Especialidad</td>
          <td>${this.selectTextEspecialidad}</td>
          </tr>
          <tr>
          <td style="background-color: #6bc048; color: #ffff">Fecha cita</td>
            <td>${cita.fechaCita}</td>
          </tr>
          <tr>
          <td style="background-color: #6bc048; color: #ffff">Hora cita</td>
            <td>${cita.horaCita}</td>
          </tr>
          <tr>
          <td style="background-color: #6bc048; color: #ffff">Lugar</td>
          <td><p>${this.selectTextCentroMedico}</p><p>${_direccion}</p></td>
          </tr>    
         
        </table> 
        
        <div style="color: #b50c0c; font-size: 15px; text-align: left; border: 1px solid #b50c0c; padding: 10px">
          <p style="font-weight: bold">Recuerda:</p>
          <ul>
            <li>Presentarte con 20 minutos de anticipación.</li>
            <li>Si deseas cancelar tu cita, por favor realízalo con 24 horas de anticipación a la fecha del servicio.</li>
          </ul>
        </div>

        </div>
        `;


          swal({
            width: 600,
            padding: 30,
            animation: true,
            allowOutsideClick: false,
            showCloseButton: true,
            title: 'Asignación cita',
            html: _html,
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-confirm-modal',
            confirmButtonText: 'Finalizar',
            buttonsStyling: false,
            focusConfirm: false,
            onOpen: () => {
              jQuery("#tableCitaMedicaConfirmada").addClass("tableCitaMedicaConfirmada");

              jQuery("#btnPrint").on('click', function () {


                var objeto = document.getElementById('contentPrinter'); //obtenemos el objeto a imprimir
                var ventana = window.open('', '_blank'); //abrimos una ventana vacía nueva
                ventana.document.write(`
                    <style>
                      #tableCitaMedicaConfirmada{
                        border: 1px solid #6bc048;
                        width: 100%;
                      }

                      #tableCitaMedicaConfirmada tr td{
                        padding: 10px;
                      }

                    </style>                  
                  `);
                //ventana.document.write('<div style="background-image: url("../assets/images/printer.png")"></div><br/>');
                ventana.document.write('<p style="text-align: center; color: #0054a5; font-size: 20px">MedPlus Medicina Prepagada</p><br/>');
                ventana.document.write('<p style="color: #0054a5; font-size: 16px">Asignación cita médica - Oficina virtual afiliados</p>');
                ventana.document.write(objeto.innerHTML); //imprimimos el HTML del objeto en la nueva ventana                  
                ventana.document.close(); //cerramos el documento
                ventana.print(); //imprimimos la ventana
                ventana.close(); //cerramos la ventana

              });
            }
          }).then((result) => {
            if (result.value) {
              this._router.navigate(['/office/medical_appointment/home']);
            } else {
              this._router.navigate(['/office/medical_appointment/home']);
            }
          });
        }
      }
    })


  }

  irHomeCitasMedicas() {
    this._router.navigate(['/office/medical_appointment/home']);
  }



}



// WEBPACK FOOTER //
// /app/src/app/office/medical-appointment/request-appointment/request-appointment.component.ts